import React from 'react';
import { SafeComponent } from '@fiverr-private/orca';
import { Container } from '@fiverr-private/layout_components';
import VideoHeroBanner from '../VideoHeroBanner';
import Hero from '../Hero';
import { useIsMobileLayout } from '../../../../shared/hooks/useIsMobileLayout';

const VideoHeroBannerWrapper = () => {
    const isMobileLayout = useIsMobileLayout(['default', 'sm']);

    return <Container>{isMobileLayout ? <Hero /> : <VideoHeroBanner />}</Container>;
};

export default SafeComponent(VideoHeroBannerWrapper);
